"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var get_1 = __importDefault(require("lodash/get"));
var pick_1 = __importDefault(require("lodash/pick"));
var remoting_1 = __importDefault(require("../actions/remoting"));
var pairing_1 = __importDefault(require("../actions/pairing"));
var Remoting = __importStar(require("../constants/remoting"));
var remoting_2 = __importDefault(require("../selectors/remoting"));
var App = __importStar(require("../constants/app"));
var nucleus_1 = require("@lifesize/nucleus");
var CONFERENCE_START_RECORDING = nucleus_1.nucleusConstants.CONFERENCE_START_RECORDING, CONFERENCE_STOP_RECORDING = nucleus_1.nucleusConstants.CONFERENCE_STOP_RECORDING;
var search = nucleus_1.directoryActions.search;
var remoteStateSelector = remoting_2.default.remoteStateSelector, wirelessPresenterStateSelector = remoting_2.default.wirelessPresenterStateSelector;
var selectCanLowerParticipantHand = nucleus_1.moderatorSelectors.selectCanLowerParticipantHand;
var proxyActionMap = (_a = {},
    _a[Remoting.service.proxyActions.add] = handleAdd,
    _a[Remoting.service.proxyActions.answer] = handleAnswer,
    _a[Remoting.service.proxyActions.call] = handleCall,
    _a[Remoting.service.proxyActions.cancelCall] = handleCancelCall,
    _a[Remoting.service.proxyActions.clearCall] = handleClearCall,
    _a[Remoting.service.proxyActions.directorySearch] = handleDirectorySearch,
    _a[Remoting.service.proxyActions.doNotDisturb] = handleDoNotDisturb,
    _a[Remoting.service.proxyActions.end] = handleEnd,
    _a[Remoting.service.proxyActions.endAndAnswer] = handleEndAndAnswer,
    _a[Remoting.service.proxyActions.ignore] = handleIgnore,
    _a[Remoting.service.proxyActions.sendMeetingPin] = handleSendMeetingPin,
    _a[Remoting.service.proxyActions.sendDtmf] = handleSendDtmf,
    _a[Remoting.service.proxyActions.toggleAudioMute] = handleToggleAudioMute,
    _a[Remoting.service.proxyActions.toggleVideoMute] = handleToggleVideoMute,
    _a[Remoting.service.proxyActions.addFavorite] = handleAddFavorite,
    _a[Remoting.service.proxyActions.removeFavorite] = handleRemoveFavorite,
    _a[Remoting.service.proxyActions.removeRecent] = handleRemoveRecent,
    _a[Remoting.service.proxyActions.raiseHand] = handleRaiseHand,
    _a[Remoting.service.proxyActions.lowerOwnHand] = handleLowerOwnHand,
    _a[Remoting.service.proxyActions.unlinkConnect] = handleUnlinkConnect,
    _a[Remoting.service.directoryActions.fetchNext] = handleFetchNext,
    _a[Remoting.service.directoryActions.fetchActiveMeetings] = handleFetchActiveMeetings,
    _a[Remoting.service.feccActions.panLeft] = handleFeccPanLeft,
    _a[Remoting.service.feccActions.panRight] = handleFeccPanRight,
    _a[Remoting.service.feccActions.zoomIn] = handleFeccZoomIn,
    _a[Remoting.service.feccActions.zoomOut] = handleFeccZoomOut,
    _a[Remoting.service.feccActions.tiltUp] = handleFeccTiltUp,
    _a[Remoting.service.feccActions.tiltDown] = handleFeccTiltDown,
    _a[Remoting.service.feccActions.panLeftStop] = handleFeccPanLeftStop,
    _a[Remoting.service.feccActions.panRightStop] = handleFeccPanRightStop,
    _a[Remoting.service.feccActions.zoomInStop] = handleFeccZoomInStop,
    _a[Remoting.service.feccActions.zoomOutStop] = handleFeccZoomOutStop,
    _a[Remoting.service.feccActions.tiltUpStop] = handleFeccTiltUpStop,
    _a[Remoting.service.feccActions.tiltDownStop] = handleFeccTiltDownStop,
    _a[Remoting.service.feccActions.moveToPreset] = handleFeccMoveToPreset,
    _a[Remoting.service.moderatorActions.muteAll] = handleModeratorMuteAll,
    _a[Remoting.service.moderatorActions.muteParticipant] = handleModeratorMuteParticipant,
    _a[Remoting.service.moderatorActions.removeParticipant] = handleModeratorRemoveParticipant,
    _a[Remoting.service.moderatorActions.endAll] = handleModeratorEndAll,
    _a[Remoting.service.moderatorActions.stopPresentation] = handleModeratorStopPresentation,
    _a[Remoting.service.moderatorActions.lockMeeting] = handleLockMeeting,
    _a[Remoting.service.moderatorActions.unlockMeeting] = handleUnlockMeeting,
    _a[Remoting.service.moderatorActions.lowerAllHands] = handleLowerAllHands,
    _a[Remoting.service.moderatorActions.lowerParticipantHand] = handleLowerParticipantHand,
    _a[Remoting.service.moderatorActions.selectParticipant] = handleSelectParticipant,
    _a[Remoting.service.wirelessActions.answer] = handleAnswerWireless,
    _a[Remoting.service.wirelessActions.end] = handleEndWireless,
    _a[Remoting.service.wirelessActions.ice] = handleIceWireless,
    _a[Remoting.service.wirelessActions.offer] = handleOfferWireless,
    _a[Remoting.service.wirelessActions.stop] = handleStopWirelessPresentationFromRemote,
    _a[Remoting.service.lifesizeConnectActions.answer] = handleAnswerLifesizeConnect,
    _a[Remoting.service.lifesizeConnectActions.end] = handleEndLifesizeConnect,
    _a[Remoting.service.lifesizeConnectActions.ice] = handleIceLifesizeConnect,
    _a[Remoting.service.lifesizeConnectActions.offer] = handleOfferLifesizeConnect,
    _a[Remoting.service.dataChannel.answer] = handleAnswerDataChannel,
    _a[Remoting.service.dataChannel.end] = handleEndDataChannel,
    _a[Remoting.service.dataChannel.ice] = handleIceDataChannel,
    _a[Remoting.service.dataChannel.offer] = handleOfferDataChannel,
    _a[CONFERENCE_START_RECORDING] = handleStartRecording,
    _a[CONFERENCE_STOP_RECORDING] = handleStopRecording,
    _a);
var remoteState = null;
var remotePresenterState = null;
function getIncomingCall(store) {
    var state = store.getState();
    var incomingCalls = nucleus_1.callSelectors.incomingCallsSelector(state);
    return incomingCalls && incomingCalls.length && incomingCalls[0];
}
function handleDirectorySearch(store, payload) {
    return store.dispatch(search(payload.searchString, payload.contactTypes, false));
}
function handleDoNotDisturb(store, payload) {
    return store.dispatch(nucleus_1.callActions.toggleDoNotDisturb(payload));
}
function handleAdd(store) {
    var incomingCall = getIncomingCall(store);
    if (incomingCall)
        store.dispatch(nucleus_1.callActions.add(incomingCall));
}
function handleAnswer(store, media) {
    if (media === void 0) { media = {}; }
    var incomingCall = getIncomingCall(store);
    if (incomingCall)
        store.dispatch(nucleus_1.callActions.answer(incomingCall, media));
}
function handleAnswerWireless(store, payload) {
    store.dispatch({ type: Remoting.actions.WIRELESS_PRESENTATION_ANSWER_RECEIVED, payload: payload });
}
function handleAnswerLifesizeConnect(store, payload) {
    store.dispatch({ type: Remoting.actions.LIFESIZE_CONNECT_ANSWER_RECEIVED, payload: payload });
}
function endDisplayWirelessPresentation(dispatch) {
    dispatch({ type: Remoting.actions.WIRELESS_PRESENTATION_EXCHANGE_PRESENTER, payload: { newPresenter: null } });
    dispatch({ type: Remoting.actions.WIRELESS_PRESENTATION_STREAM_ENDED });
}
function endDisplayLifesizeConnect(dispatch) {
    dispatch({ type: Remoting.actions.LIFESIZE_CONNECT_EXCHANGE_PRESENTER, payload: { newConnector: null } });
    dispatch({ type: Remoting.actions.LIFESIZE_CONNECT_STREAM_ENDED });
}
/**
 * stop the wireless presentation from the remote (tablet)
 * @param {*} store
 */
function handleStopWirelessPresentationFromRemote(store) {
    endDisplayWirelessPresentation(store.dispatch);
}
/**
 * ends the wireless presentation (if the active presenter is the one who sent the 'end' request)
 * @param {*} store
 * @param {*} payload
 * @param {*} from the uuid of the device sending the message
 */
function handleEndWireless(store, payload, from) {
    var state = store.getState();
    var activePresenter = get_1.default(state, 'app.remoting.pairing.activePresenter');
    var isDisplay = get_1.default(state, 'app.remoting.pairing.isDisplay');
    if (isDisplay && from && activePresenter === from) {
        endDisplayWirelessPresentation(store.dispatch);
    }
}
function handleEndLifesizeConnect(store, payload, from) {
    var state = store.getState();
    var activeConnecter = get_1.default(state, 'app.remoting.pairing.activeConnecter');
    var isDisplay = get_1.default(state, 'app.remoting.pairing.isDisplay');
    if (isDisplay && from && activeConnecter === from) {
        endDisplayLifesizeConnect(store.dispatch);
    }
}
function handleIceWireless(store, payload) {
    store.dispatch({ type: Remoting.actions.WIRELESS_PRESENTATION_ICECANDIDATE, payload: payload });
}
function handleIceLifesizeConnect(store, payload) {
    store.dispatch({ type: Remoting.actions.LIFESIZE_CONNECT_ICECANDIDATE, payload: payload });
}
function handleOfferWireless(store, payload, newPresenter) {
    var state = store.getState();
    /* checking the ability to present immediately before handling the wireless offer helps prevent the race condition
     * coming from the presenter where the present button is still enabled (or the presentation selector is already
     * visible) at the time the remote caller starts presenting */
    var canPresent = wirelessPresenterStateSelector(state).canPresent;
    if (canPresent) {
        var activePresenter = get_1.default(state, 'app.remoting.pairing.activePresenter');
        var isDisplay = get_1.default(state, 'app.remoting.pairing.isDisplay');
        // a new offer is being received by the display from a new presenter; stop the outgoing presentation on the active presenter
        if (isDisplay && newPresenter && activePresenter !== newPresenter) {
            if (activePresenter)
                store.dispatch(remoting_1.default.sendToDisplay.wireless.end());
            store.dispatch({ type: Remoting.actions.WIRELESS_PRESENTATION_EXCHANGE_PRESENTER, payload: { newPresenter: newPresenter } });
        }
        store.dispatch({ type: Remoting.actions.WIRELESS_PRESENTATION_OFFER_RECEIVED, payload: payload });
    }
}
function handleOfferLifesizeConnect(store, payload, newConnecter) {
    var state = store.getState();
    var activeConnecter = get_1.default(state, 'app.remoting.pairing.activeConnecter');
    var isDisplay = get_1.default(state, 'app.remoting.pairing.isDisplay');
    // a new offer is being received by the display from a new presenter; stop the outgoing presentation on the active presenter
    if (isDisplay && newConnecter && activeConnecter !== newConnecter) {
        if (activeConnecter)
            store.dispatch(remoting_1.default.sendToDisplay.lifesizeConnect.end());
        store.dispatch({ type: Remoting.actions.LIFESIZE_CONNECT_EXCHANGE_PRESENTER, payload: { newConnecter: newConnecter } });
    }
    store.dispatch({ type: Remoting.actions.LIFESIZE_CONNECT_OFFER_RECEIVED, payload: payload });
}
function handleAnswerDataChannel(store, payload) {
    store.dispatch({ type: Remoting.actions.DATA_CHANNEL_ANSWER_RECEIVED, payload: payload });
}
function handleEndDataChannel(store) {
    store.dispatch({ type: Remoting.actions.DATA_CHANNEL_STREAM_ENDED });
}
function handleIceDataChannel(store, payload) {
    store.dispatch({ type: Remoting.actions.DATA_CHANNEL_ICECANDIDATE, payload: payload });
}
function handleOfferDataChannel(store, payload) {
    store.dispatch({ type: Remoting.actions.DATA_CHANNEL_OFFER_RECEIVED, payload: payload });
}
function handleCall(store, payload) {
    var media = get_1.default(payload, 'media');
    var contact = get_1.default(payload, 'contact');
    store.dispatch(nucleus_1.callActions.call(contact, media));
}
function handleCancelCall(store, payload) {
    store.dispatch(nucleus_1.callActions.cancel(payload));
}
function handleClearCall(store) {
    store.dispatch(nucleus_1.callActions.clearCall());
}
function handleEnd(store) {
    store.dispatch(nucleus_1.callActions.end());
}
function handleEndAndAnswer(store) {
    var incomingCall = getIncomingCall(store);
    if (incomingCall)
        store.dispatch(nucleus_1.callActions.endAndAnswer(incomingCall));
}
function handleIgnore(store) {
    var incomingCall = getIncomingCall(store);
    if (incomingCall)
        store.dispatch(nucleus_1.callActions.ignore(incomingCall));
}
function handleSendMeetingPin(store, pin) {
    store.dispatch(nucleus_1.callActions.sendMeetingPin(pin));
}
function handleSendDtmf(store, key) {
    store.dispatch(nucleus_1.callActions.sendDtmf(key));
}
function handleStartRecording(store, owner) {
    store.dispatch(nucleus_1.callActions.startRecording(owner));
}
function handleStopRecording(store) {
    store.dispatch(nucleus_1.callActions.stopRecording());
}
function handleToggleVideoMute(store, payload) {
    store.dispatch(nucleus_1.streamActions.toggleVideoMute(payload));
}
function handleToggleAudioMute(store, payload) {
    store.dispatch(nucleus_1.streamActions.setAudioMuteState(payload));
}
function handleModeratorMuteAll(store, shouldMute) {
    store.dispatch(nucleus_1.callActions.muteAll(shouldMute));
}
function handleModeratorMuteParticipant(store, payload) {
    var participant = get_1.default(payload, 'participant');
    var shouldMute = get_1.default(payload, 'shouldMute');
    store.dispatch(nucleus_1.callActions.muteParticipant(participant, shouldMute));
}
function handleModeratorRemoveParticipant(store, participant) {
    store.dispatch(nucleus_1.callActions.kick(participant));
}
function handleModeratorEndAll(store) {
    store.dispatch(nucleus_1.callActions.kickAll());
}
function handleModeratorStopPresentation(store) {
    store.dispatch(nucleus_1.moderatorActions.stopCurrentConferencePresentation());
}
function handleLockMeeting(store) {
    store.dispatch(nucleus_1.moderatorActions.lockCurrentConference());
}
function handleUnlockMeeting(store) {
    store.dispatch(nucleus_1.moderatorActions.unlockCurrentConference());
}
function handleFeccPanLeft(store) {
    store.dispatch(nucleus_1.feccActions.panLeft());
}
function handleFeccPanRight(store) {
    store.dispatch(nucleus_1.feccActions.panRight());
}
function handleFeccZoomIn(store) {
    store.dispatch(nucleus_1.feccActions.zoomIn());
}
function handleFeccZoomOut(store) {
    store.dispatch(nucleus_1.feccActions.zoomOut());
}
function handleFeccTiltUp(store) {
    store.dispatch(nucleus_1.feccActions.tiltUp());
}
function handleFeccTiltDown(store) {
    store.dispatch(nucleus_1.feccActions.tiltDown());
}
function handleFeccPanLeftStop(store) {
    store.dispatch(nucleus_1.feccActions.panLeftStop());
}
function handleFeccPanRightStop(store) {
    store.dispatch(nucleus_1.feccActions.panRightStop());
}
function handleFeccZoomInStop(store) {
    store.dispatch(nucleus_1.feccActions.zoomInStop());
}
function handleFeccZoomOutStop(store) {
    store.dispatch(nucleus_1.feccActions.zoomOutStop());
}
function handleFeccTiltUpStop(store) {
    store.dispatch(nucleus_1.feccActions.tiltUpStop());
}
function handleFeccTiltDownStop(store) {
    store.dispatch(nucleus_1.feccActions.tiltDownStop());
}
function handleFeccMoveToPreset(store, preset) {
    var command = 'cameraMoveToPreset';
    var param = { preset: preset, command: command };
    store.dispatch(nucleus_1.feccActions.preset(param));
}
function handleAddFavorite(store, contact) {
    var type = get_1.default(contact, 'contactType');
    var uuid = get_1.default(contact, 'id');
    store.dispatch(nucleus_1.favoriteActions.addFavorite(type, uuid));
}
function handleRemoveFavorite(store, contact) {
    var uuid = get_1.default(contact, 'id');
    store.dispatch(nucleus_1.favoriteActions.deleteFavorite(uuid));
}
function handleRemoveRecent(store, item) {
    store.dispatch(nucleus_1.callHistoryActions.callHistoryDelete(item));
}
function handleRaiseHand(store) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, store.dispatch(nucleus_1.usersActions.raiseHand())];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    store.dispatch({
                        type: App.actions.setRaiseHandErrors,
                        payload: App.errors.RAISE_HAND_FAILED
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function handleLowerOwnHand(store) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, store.dispatch(nucleus_1.usersActions.lowerOwnHand())];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    store.dispatch({
                        type: App.actions.setRaiseHandErrors,
                        payload: App.errors.LOWER_HAND_FAILED
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function handleLowerAllHands(store) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, store.dispatch(nucleus_1.moderatorActions.lowerAllRaisedHands())];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    store.dispatch({
                        type: App.actions.setRaiseHandErrors,
                        payload: App.errors.LOWER_ALL_HANDS_FAILED
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function handleLowerParticipantHand(store, participantId) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, store.dispatch(nucleus_1.moderatorActions.lowerParticipantHand(participantId))];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    store.dispatch({
                        type: App.actions.setRaiseHandErrors,
                        payload: App.errors.LOWER_PARTICIPANT_HAND_FAILED
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function handleUnlinkConnect(store, connectId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, store.dispatch(pairing_1.default.unlinkConnect(connectId))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function handleFetchNext(store, payload) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, store.dispatch(nucleus_1.directoryActions.fetchNext(payload.filter, payload.pageLoadSize))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function handleFetchActiveMeetings(store) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, store.dispatch(nucleus_1.directoryActions.loadActiveMeetings())];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function handleSelectParticipant(store, participant) {
    // Note: This pattern is used specifically for RCA and should not be used in other apps.
    // The RCA does not have the full nucleus state, so it must notify the Display to select the approriate data on demand.
    // This will store the updated participant object in the app state, which is then returned to the RCA.
    var canLowerParticipantHand = selectCanLowerParticipantHand(store.getState(), get_1.default(participant, 'participantId'));
    var selectedParticipant = participant ? __assign(__assign({}, participant), { canLowerParticipantHand: canLowerParticipantHand }) : null;
    store.dispatch({ type: App.actions.selectParticipant, payload: selectedParticipant });
}
/**
 * Compares two objects and returns the difference.
 * Intended to be used only to optimize size of the state that gets sent down to the remote.
 * @param {Object} original The source of the comparison (old object)
 * @param {Object} target The target of the comparison (new object)
 */
function getDifference(original, target) {
    var diffKeys = Object.keys(target).filter(function (k) { return !isEqual_1.default(original[k], target[k]); });
    return pick_1.default(target, diffKeys);
}
/**
 * Sends a subset of the state from the display to the remote control, if it is different from the last one sent.
 * @param {*} store The redux store
 * @param {*} state The redux state
 * @param {boolean} force A flag indicating if the state should be sent regardless of changes
 */
function sendState(store, state, force) {
    if (force === void 0) { force = false; }
    var isDataChannelOpen = get_1.default(state, 'nucleus.dataChannel.open');
    if (!isDataChannelOpen)
        return;
    var newRemoteState = remoteStateSelector(state);
    var sendCompleteState = force || remoteState === null || typeof remoteState !== 'object';
    if (sendCompleteState) {
        remoteState = newRemoteState;
        return store.dispatch(remoting_1.default.sendState(newRemoteState, true));
    }
    else if (!isEqual_1.default(newRemoteState, remoteState)) {
        var diff = getDifference(remoteState, newRemoteState);
        remoteState = newRemoteState;
        return store.dispatch(remoting_1.default.sendState(diff));
    }
}
/**
 * Sends a subset of the state from the display to the wireless presenter(s), if it is different from the last one sent.
 * @param {*} store The redux store
 * @param {*} state The redux state
 * @param {boolean} force A flag indicating if the state should be sent regardless of changes
 */
function sendPresenterState(store, state, force) {
    if (force === void 0) { force = false; }
    var newRemotePresenterState = wirelessPresenterStateSelector(state);
    if (force || !isEqual_1.default(newRemotePresenterState, remotePresenterState)) {
        remotePresenterState = newRemotePresenterState;
        return store.dispatch(remoting_1.default.sendPresenterState(newRemotePresenterState));
    }
}
/**
 * Handles a proxy action received through the remote channel
 * @param {*} store The redux store
 * @param {string} type The proxy action received
 * @param {*} payload The proxy action payload
 */
function handleProxyAction(store, type, payload, from) {
    var proxyActionHandler = proxyActionMap[type];
    if (proxyActionHandler)
        return proxyActionHandler(store, payload, from);
    // Dispatch action as is if it is not in the map
    return store.dispatch({ type: type, payload: payload });
}
exports.default = { handleProxyAction: handleProxyAction, sendPresenterState: sendPresenterState, sendState: sendState };
